import { Segments } from './types';

const formatSrtTime = (timeSeconds: number): string => {
  const totalMilliseconds = Math.max(0, Math.round(timeSeconds * 1000));
  const hours = Math.floor(totalMilliseconds / 3600000);
  const minutes = Math.floor((totalMilliseconds % 3600000) / 60000);
  const seconds = Math.floor((totalMilliseconds % 60000) / 1000);
  const milliseconds = totalMilliseconds % 1000;

  const pad2 = (n: number) => String(n).padStart(2, '0');
  const pad3 = (n: number) => String(n).padStart(3, '0');

  return `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)},${pad3(milliseconds)}`;
};

const convertTranscriptToSrt = (transcript: Segments): string => {
  if (!transcript || !Array.isArray(transcript.segments)) return '';

  const orderedSegments = [...transcript.segments]
    .filter(
      (s) =>
        s &&
        typeof s.start === 'number' &&
        typeof s.end === 'number' &&
        s.text &&
        s.text.trim() !== '',
    )
    .sort((a, b) => a.start - b.start);

  const lines: string[] = [];
  for (let index = 0; index < orderedSegments.length; index += 1) {
    const segment = orderedSegments[index];
    const safeStart = Math.max(0, segment.start);
    const safeEnd = Math.max(safeStart, segment.end);
    lines.push(String(index + 1));
    lines.push(`${formatSrtTime(safeStart)} --> ${formatSrtTime(safeEnd)}`);
    lines.push(segment.text.replace(/\r/g, '').trim());
    lines.push('');
  }

  return lines.join('\n');
};

export const downloadSrt = (transcript: Segments, filename: string): void => {
  const srt = convertTranscriptToSrt(transcript);
  const blob = new Blob([srt], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
};
